export default __webpack_public_path__ + "static/media/Patricia_Manley_AHV_In_Moms_We_Trust.2b36be2e.jpg";